<goab-form-item
  requirement="required"
  labelSize="regular"
  [style.display]="!isForEmptyBedsReasons() ? 'block' : 'none'"
>
  <goab-radio-group
    name="empty-beds-radio-group"
    [attr.data-testid]="'empty-beds-radio-group'"
    [formControl]="formGroup.controls.hasEmptyBeds"
    [value]="formGroup.controls.hasEmptyBeds.value"
    (onChange)="onHasEmptyBedsChange($event)"
  >
    <goab-radio-item
      [attr.data-testid]="'empty-beds-yes-radio-item'"
      tabindex="0"
      label="Yes"
      value="true"
    ></goab-radio-item>
    <goab-radio-item
      [attr.data-testid]="'empty-beds-no-radio-item'"
      tabindex="0"
      label="No"
      value="false"
      style="margin-top: -5px"
    ></goab-radio-item>
  </goab-radio-group>
</goab-form-item>
<!--Empty beds reasons-->
<div
  class="entry-container"
  *ngIf="isForEmptyBedsReasons() && currentFacilityBed().hasEmptyBeds === true"
>
  <goab-table width="100%" variant="normal">
    <thead>
      <tr>
        <th width="55%">Select reason(s)</th>
        <th width="20%">Last week’s input</th>
        <th width="25%">Number of empty beds</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="3" class="sub-title">
          Open beds - available for ALA referral
        </td>
      </tr>
      <tr>
        <td>1. No referral, less than 1 week</td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-openBedLessTwoWeekReferral-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-openBedLessTwoWeekReferral-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.openBedLessTwoWeekReferral?.previous
          | emptyValueMask}}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('openBedLessTwoWeekReferral'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-openBedLessTwoWeekReferral-input'"
              [attr.id]="bedType() + '-empty-beds-reason-openBedLessTwoWeekReferral-input'"
              [formControl]="formGroup.controls.openBedLessTwoWeekReferral"
              [name]="'openBedLessTwoWeekReferral'"
              [value]="formGroup.controls.openBedLessTwoWeekReferral.value"
              [error]="formGroup.controls.openBedLessTwoWeekReferral.invalid && formGroup.controls.openBedLessTwoWeekReferral.touched"
              (onChange)="onEmptyBedReasonChange('openBedLessTwoWeekReferral', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>2. No referral, 1 week or more</td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-openBedTwoWeekNoReferral-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-openBedTwoWeekNoReferral-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.openBedTwoWeekNoReferral?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('openBedTwoWeekNoReferral'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-openBedTwoWeekNoReferral-input'"
              [attr.id]="bedType() + '-empty-beds-reason-openBedTwoWeekNoReferral-input'"
              [name]="'openBedTwoWeekNoReferral'"
              [formControl]="formGroup.controls.openBedTwoWeekNoReferral"
              [value]="formGroup.controls.openBedTwoWeekNoReferral.value"
              [error]="formGroup.controls.openBedTwoWeekNoReferral.invalid && formGroup.controls.openBedTwoWeekNoReferral.touched"
              (onChange)="onEmptyBedReasonChange('openBedTwoWeekNoReferral', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>
          <goab-text
            [attr.data-testid]="'help-section-1-content-para-1'"
            size="body-m"
            tag="span"
            mt="none"
            mb="none"
          >
            3. Bed mismatch - Physical/functional
          </goab-text>
          <div class="help-text">
            <goab-text
              [attr.data-testid]="'help-section-1-content-para-1'"
              size="body-xs"
              tag="span"
              mb="none"
              mt="none"
            >
              (Mobility, bariatric needs, etc.)
            </goab-text>
          </div>
        </td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-bedMismatchPhysical-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-bedMismatchPhysical-previous-week-input'"
        >
          {{ currentFacilityBed().emptyBedReasons?.bedMismatchPhysical?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('bedMismatchPhysical'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchPhysical-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchPhysical-input'"
              [name]="'bedMismatchPhysical'"
              [formControl]="formGroup.controls.bedMismatchPhysical"
              [value]="formGroup.controls.bedMismatchPhysical.value"
              [error]="formGroup.controls.bedMismatchPhysical.invalid && formGroup.controls.bedMismatchPhysical.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchPhysical', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>
          <goab-text
            [attr.data-testid]="'help-section-1-content-para-1'"
            size="body-m"
            tag="span"
            mt="none"
            mb="none"
          >
            4. Bed mismatch - Smoking
          </goab-text>
          <div class="help-text">
            <goab-text
              [attr.data-testid]="'help-section-1-content-para-1'"
              size="body-xs"
              tag="span"
              mb="none"
              mt="none"
            >
              (No safe smoking area for a smoker.)
            </goab-text>
          </div>
        </td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-bedMismatchSmoking-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-bedMismatchSmoking-previous-week-input'"
        >
          {{ currentFacilityBed().emptyBedReasons?.bedMismatchSmoking?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item [error]="getErrors(getControl('bedMismatchSmoking'))">
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchSmoking-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchSmoking-input'"
              [name]="'bedMismatchSmoking'"
              [formControl]="formGroup.controls.bedMismatchSmoking"
              [value]="formGroup.controls.bedMismatchSmoking.value"
              [error]="formGroup.controls.bedMismatchSmoking.invalid && formGroup.controls.bedMismatchSmoking.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchSmoking', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>
          <goab-text
            [attr.data-testid]="'help-section-1-content-para-1'"
            size="body-m"
            tag="span"
            mt="none"
            mb="none"
          >
            5. Bed mismatch - Peer/gender
          </goab-text>
          <div class="help-text">
            <goab-text
              [attr.data-testid]="'help-section-1-content-para-1'"
              size="body-xs"
              tag="span"
              mb="none"
              mt="none"
            >
              (Shared room occupant, a floor dedicated to a given peer group or
              gender.)
            </goab-text>
          </div>
        </td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-bedMismatchPeerGender-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-bedMismatchPeerGender-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.bedMismatchPeerGender?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('bedMismatchPeerGender'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchPeerGender-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchPeerGender-input'"
              [name]="'bedMismatchPeerGender'"
              [formControl]="formGroup.controls.bedMismatchPeerGender"
              [value]="formGroup.controls.bedMismatchPeerGender.value"
              [error]="formGroup.controls.bedMismatchPeerGender.invalid && formGroup.controls.bedMismatchPeerGender.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchPeerGender', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>
          <goab-text
            [attr.data-testid]="'help-section-1-content-para-1'"
            size="body-m"
            tag="span"
            mt="none"
            mb="none"
          >
            6. Bed mismatch - Equipment/furniture
          </goab-text>
          <br />
          <div class="help-text">
            <goab-text
              [attr.data-testid]="'help-section-1-content-para-1'"
              size="body-xs"
              tag="span"
              mb="none"
              mt="none"
            >
              (Facility does not have the required equipment to meet client
              needs, eg. Lift, dialysis.)
            </goab-text>
          </div>
        </td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-bedMismatchEquipment-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-bedMismatchEquipment-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.bedMismatchEquipment?.previous |
          emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('bedMismatchEquipment'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchEquipment-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchEquipment-input'"
              [name]="'bedMismatchEquipment'"
              [formControl]="formGroup.controls.bedMismatchEquipment"
              [value]="formGroup.controls.bedMismatchEquipment.value"
              [error]="formGroup.controls.bedMismatchEquipment.invalid && formGroup.controls.bedMismatchEquipment.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchEquipment', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>
          <goab-text
            [attr.data-testid]="'help-section-1-content-para-1'"
            size="body-m"
            tag="span"
            mt="none"
            mb="none"
          >
            7. Bed mismatch - Cognitive, mental health, or addictions
          </goab-text>
          <div class="help-text">
            <goab-text
              [attr.data-testid]="'help-section-1-content-para-1'"
              size="body-xs"
              tag="span"
              mb="none"
              mt="none"
            >
              (Complex issues beyond scope of facility to provide care.)
            </goab-text>
          </div>
        </td>
        <td>
          {{
          currentFacilityBed().emptyBedReasons?.bedMismatchCognitive?.previous |
          emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('bedMismatchCognitive'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchCognitive-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchCognitive-input'"
              [name]="'bedMismatchCognitive'"
              [formControl]="formGroup.controls.bedMismatchCognitive"
              [value]="formGroup.controls.bedMismatchCognitive.value"
              [error]="formGroup.controls.bedMismatchCognitive.invalid && formGroup.controls.bedMismatchCognitive.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchCognitive', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td>8. Bed mismatch - Client refusal</td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-bedMismatchClientRefusal-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-bedMismatchClientRefusal-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.bedMismatchClientRefusal?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('bedMismatchClientRefusal'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() + '-empty-beds-reason-bedMismatchClientRefusal-input'"
              [attr.id]="bedType() + '-empty-beds-reason-bedMismatchClientRefusal-input'"
              [name]="'bedMismatchClientRefusal'"
              [formControl]="formGroup.controls.bedMismatchClientRefusal"
              [value]="formGroup.controls.bedMismatchClientRefusal.value"
              [error]="formGroup.controls.bedMismatchClientRefusal.invalid && formGroup.controls.bedMismatchClientRefusal.touched"
              (onChange)="onEmptyBedReasonChange('bedMismatchClientRefusal', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="sub-title">On hold beds</td>
      </tr>
      <tr>
        <td>9. Pending or matched admission</td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-onHoldPendingOrMatched-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-onHoldPendingOrMatched-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.onHoldPendingOrMatched?.previous
          | emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('onHoldPendingOrMatched'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType() +'-empty-beds-reason-onHoldPendingOrMatched-input'"
              [attr.id]="bedType() +'-empty-beds-reason-onHoldPendingOrMatched-input'"
              [name]="'onHoldPendingOrMatched'"
              [formControl]="formGroup.controls.onHoldPendingOrMatched"
              [value]="formGroup.controls.onHoldPendingOrMatched.value"
              [error]="formGroup.controls.onHoldPendingOrMatched.invalid && formGroup.controls.onHoldPendingOrMatched.touched"
              (onChange)="onEmptyBedReasonChange('onHoldPendingOrMatched', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="sub-title">Temporary closure</td>
      </tr>
      <tr>
        <td>
          10. Long-term maintenance, staff issues, infection control, or other
          operational reasons
        </td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-tempCloseMaintenance-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-tempCloseMaintenance-previous-week-input'"
        >
          {{
          currentFacilityBed().emptyBedReasons?.tempCloseMaintenance?.previous |
          emptyValueMask }}
        </td>
        <td>
          <goab-form-item
            [error]="getErrors(getControl('tempCloseMaintenance'))"
          >
            <goab-input-number
              [attr.data-testid]="bedType()+'-empty-beds-reason-tempCloseMaintenance-input'"
              [attr.id]="bedType()+'-empty-beds-reason-tempCloseMaintenance-input'"
              [name]="'tempCloseMaintenance'"
              [formControl]="formGroup.controls.tempCloseMaintenance"
              [value]="formGroup.controls.tempCloseMaintenance.value"
              [error]="formGroup.controls.tempCloseMaintenance.invalid && formGroup.controls.tempCloseMaintenance.touched"
              (onChange)="onEmptyBedReasonChange('tempCloseMaintenance', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="sub-title">Temporary use</td>
      </tr>
      <tr>
        <td>11. Use for respite, acute, or other care type</td>
        <td
          [attr.data-testid]="bedType()+'-empty-beds-reason-tempCloseOther-previous-week-input'"
          [attr.id]="bedType()+'-empty-beds-reason-tempCloseOther-previous-week-input'"
        >
          {{ currentFacilityBed().emptyBedReasons?.tempCloseOther?.previous |
          emptyValueMask }}
        </td>
        <td>
          <goab-form-item [error]="getErrors(getControl('tempCloseOther'))">
            <goab-input-number
              [attr.data-testid]="bedType()+'-empty-beds-reason-tempCloseOther-input'"
              [attr.id]="bedType()+'-empty-beds-reason-tempCloseOther-input'"
              [name]="'tempCloseOther'"
              [formControl]="formGroup.controls.tempCloseOther"
              [value]="formGroup.controls.tempCloseOther.value"
              [error]="formGroup.controls.tempCloseOther.invalid && formGroup.controls.tempCloseOther.touched"
              (onChange)="onEmptyBedReasonChange('tempCloseOther', $event)"
              (onBlur)="onEmptyBedReasonBlur($any($event))"
              tabindex="0"
              type="number"
              width="11ch"
            ></goab-input-number>
          </goab-form-item>
        </td>
      </tr>
      <tr>
        <td class="sub-title">TOTAL:</td>
        <td
          class="sub-title"
          [attr.data-testid]="bedType()+'-empty-beds-reason-total-last-week-beds'"
          [attr.id]="bedType()+'-empty-beds-reason-total-last-week-beds'"
        >
          {{ totalLastWeekInput() | emptyValueMask }}
        </td>
        <td
          class="sub-title"
          [attr.data-testid]="bedType()+'-empty-beds-reason-total-current-week-beds'"
          [attr.id]="bedType()+'-empty-beds-reason-total-current-week-beds'"
        >
          {{ totalThisWeekBedsEntry() | emptyValueMask }}
        </td>
      </tr>
    </tbody>
  </goab-table>
</div>
